import { createApp } from 'vue'
import { createPinia } from 'pinia'

import App from './App.vue'
import router from './router/router.js'

import {store as piniaStore} from './store/store.js'

import store from './store'
import utils from './plugins/utils'
import api from './plugins/api'

import '../src/assets/style.css'
import '../src/assets/responsive.css'
import '../src/assets/new-style.scss'
import '../src/assets/styles/main.scss';

import moment from 'moment'
import axios from 'axios'
import VueAxios from 'vue-axios'
import jQuery from "jquery"
import {checkServiceWorkerVersion, refreshServiceWorker} from './registerServiceWorker.js'
import { appType, telegramContact } from './appType/appType.js'
import { envName, lang, yandexCaptchaEnabled } from './plugins/utils.js'
import { useAuthStore } from '@/store/stores/auth'

const $ = jQuery
window.$ = $

// TODO: сделать настраиваемым
if (yandexCaptchaEnabled) {
  const script = document.createElement('script')
  script.src = `https://smartcaptcha.yandexcloud.net/captcha.js?hl=${lang}`
  script.defer = true
  document.head.appendChild(script)
}

console.log(appType, import.meta.env.VUE_APP_VERSION)

void async function check() {
    const isLastVersion = await checkServiceWorkerVersion()
    if(!isLastVersion) {
        console.error('refresh')
        await refreshServiceWorker()
    }
}()

const pinia = createPinia()

const app = createApp(App)
    .use(pinia)
    .use(moment)
    .use($)
    .use(store)
    .use(VueAxios, axios)
    .use(router)
    .use(utils)
    .use(api)

piniaStore.init()

app.config.errorHandler = (err, vm, info) => {
    console.error("Error:", err);
    console.error("Vue component:", vm);
    console.error("Additional info:", info);
};

window.onerror = (message, source, lineno, colno, error) => {
    console.error('Global JavaScript Error:', message, source, lineno, colno, error);
    // store.dispatch('handleError', { err: error || message });
};

// Global uncaught promise rejection handler
window.addEventListener('unhandledrejection', (event) => {
    let error = event.reason;

    /*
    if (Object.hasOwn(error, 'response')) {
        if (Object.hasOwn(error.response, 'data')) {
            if (Object.hasOwn(error.response.data, 'code')) {
                if (error.response.data.code === 'INVALID_TOKEN') {
                    alert('token invalid')
                }
            }
        }
    } else {
        console.error('Unhandled Rejection (My):', event.reason);
    }
    */
    // Render the error page component
    // renderErrorPage(event.reason.message || 'An unexpected error has occurred.');
})


app.mount('#app')

// запись в authStore - appType (telegram / web)
const authStore = useAuthStore()
authStore.appType = appType

// запись в стор данных из телеграма если такие получены от пользователя
// if ( telegramContact ) {
//     console.log('main.js telegramContact ---> ', telegramContact)
//     const authStore = useAuthStore()
//     authStore.toggleLoader()
//     authStore.telegramContact = telegramContact
// }


